import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import Home from '@/views/Home'
import About from '@/views/About'
import Data from '@/views/Data'
import Projects from '@/views/Projects'
import Publications from '@/views/Publications'
import Project from '@/views/Project'
import Instruments from '@/views/Instruments'
import Contacts from '@/views/Contacts'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/data',
      name: 'Data',
      component: Data
    },
    {
      path: '/data/:id',
      name: 'DataProjects',
      component: Data
    },
    {
      path: '/projects',
      name: 'Projects',
      component: Projects
    },
    {
      path: '/projects/:id',
      name: 'Project',
      component: Project
    },
    {
      path: '/instruments',
      name: 'Instruments',
      component: Instruments
    },
    {
      path: '/instruments/:type',
      name: 'Instruments Type',
      component: Instruments
    },
    {
      path: '/contacts',
      name: 'Contacts',
      component: Contacts
    },
    {
      path: '/publications',
      name: 'Publications',
      component: Publications
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    // return desired position
    return { x: 0, y: 0 }
  }
})

router.afterEach((to, from) => {
  // Close Mobile menu
  if (document.body.className === 'open-menu') {
    document.body.classList.toggle('open-menu')
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js